import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import {
  showTranslationsNewLanguages,
  cl1511NHConsentMvp as cl1511NHConsentMvpSelector,
} from 'common/utils/FeatureFlags/flags';
import { updateGlobalState } from 'actions/Global/globalActions';
import { CONSENT_APP_URL } from 'src/config/env/env.config';
import { LanguageSelector } from '@unite-us/app-components';
import RequestOrUploadConsentForm from './RequestOrUploadConsentForm';
import '../stylesheets/informedConsent.scss';

const buildConsentAppUrl = (contactId, contact, currentEmployee, submissionMethod, language, showNHConsent) => {
  const params = new URLSearchParams({
    person_id: contactId,
    first_name: contact.first_name || '',
    last_name: contact.last_name || '',
    employee_id: currentEmployee.id,
    employee_fullname: currentEmployee.full_name || '',
    submission_method: submissionMethod,
    'form-only': '',
    show_nh_consent: showNHConsent,
    language,
  });

  return `${CONSENT_APP_URL}?${params.toString()}`;
};

class ConsentReferrals extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showConsentApp: false,
      showConsentAppAttestation: false,
      consentAppUrl: '',
      currentLanguage: props.language,
      field: {},
      registerField: null,
    };

    this.hideConsent = this.hideConsent.bind(this);
    this.showConsent = this.showConsent.bind(this);
    this.setConsentAttestation = this.setConsentAttestation.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.getConsentAppUrl = this.getConsentAppUrl.bind(this);
  }

  handleOnChange(val, field, registerField) {
    const indexToReplace = this.state.consentAppUrl.lastIndexOf('language=') + 'language'.length;
    if (indexToReplace !== -1) {
      const trimURL = this.state.consentAppUrl.substring(0, indexToReplace);
      const newURL = trimURL.concat(`=${val}`);
      this.props.updateGlobalState({
        language: val,
      });
      this.setState({
        consentAppUrl: newURL,
        currentLanguage: val,
        field,
        registerField,
      });
    }
  }

  getConsentAppUrl(groupId, contactId, contact, consentAttestation) {
    const { currentEmployee, showNHConsent } = this.props;

    if (!contactId) {
      return;
    }

    const submission_method = consentAttestation === true ? 'attestation' : '';
    this.setState({
      consentAppUrl: buildConsentAppUrl(
        contactId,
        contact,
        currentEmployee,
        submission_method,
        this.state.currentLanguage,
        showNHConsent,
      ),
      showConsentAppAttestation: consentAttestation === true,
    });
  }

  setConsentAttestation(value) {
    this.setState({ showConsentAppAttestation: value });
  }

  hideConsent() {
    this.setState({ showConsentApp: false });
  }

  showConsent(field, registerField) {
    this.setState({
      showConsentApp: true,
      field,
      registerField,
    });
  }

  render() {
    const {
      contact,
      initializedValue,
      shouldShowTranslationsNewLanguages,
    } = this.props;
    const {
      showConsentApp,
      consentAppUrl,
      field,
      registerField,
      showConsentAppAttestation,
    } = this.state;

    const Title = (showConsentApp && !showConsentAppAttestation) ? (
      <div className="text-xl p-4 border-b border-solid border-dark-border-blue flex justify-between">
        <div className="pl-2">Informed Consent</div>
        <LanguageSelector
          onChange={this.handleOnChange}
          field={field}
          registerField={registerField}
          translationsNewLanguageFlag={shouldShowTranslationsNewLanguages}
        />
      </div>
    ) : (
      <div className="text-xl p-4 border-b border-solid border-dark-border-blue">
        <div className="pt-2 pl-2">Informed Consent</div>
      </div>
    );

    return (
      <div className="bg-white mt-10 border border-solid border-dark-border-blue rounded">
        { Title }
        <div className="p-4">
          <RequestOrUploadConsentForm
            contact={contact}
            contactId={contact.id}
            hideConsent={this.hideConsent}
            initializedValue={initializedValue}
            onNavigateAway={this.props.onNavigateAway}
            setConsentAttestation={this.setConsentAttestation}
            showConsent={this.showConsent}
            showConsentApp={this.state.showConsentApp}
            showConsentAppAttestation={this.state.showConsentAppAttestation}
            handleOnChange={this.handleOnChange}
            consentAppUrl={consentAppUrl}
            getConsentAppUrl={this.getConsentAppUrl}
          />
        </div>
      </div>
    );
  }
}

ConsentReferrals.propTypes = {
  contact: PropTypes.shape({
    id: PropTypes.string,
  }),
  currentEmployee: PropTypes.object.isRequired,
  initializedValue: PropTypes.string,
  onNavigateAway: PropTypes.func,
  shouldShowTranslationsNewLanguages: PropTypes.bool,
  language: PropTypes.string,
  updateGlobalState: PropTypes.func.isRequired,
  showNHConsent: PropTypes.bool.isRequired,
};

ConsentReferrals.defaultProps = {
  contact: {},
  initializedValue: '',
  onNavigateAway: () => {},
  language: 'en',
  shouldShowTranslationsNewLanguages: false,
};

function mapStateToProps(state) {
  const language = state.globalState.language;
  const currentEmployee = state.globalState.currentEmployee;
  const provider_region = state.globalState.currentProvider?.group?.provider_region ||
      state.session?.currentProvider?.provider_region;
  const showNHConsent = cl1511NHConsentMvpSelector(state) && provider_region === 'New Hampshire';

  return {
    language,
    shouldShowTranslationsNewLanguages: showTranslationsNewLanguages(state),
    showNHConsent,
    currentEmployee,
  };
}

export default connect(mapStateToProps, {
  updateGlobalState,
}, null, { forwardRef: true })(ConsentReferrals);
